var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('img',{staticClass:"img-fluid mb-2",attrs:{"src":_vm.image,"alt":_vm.title,"loading":"lazy","decoding":"async"}}),_c('h3',{staticClass:"beta fw-semibold"},[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }